import { v4 as uuid } from "uuid";

export const videos = [
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/2Oy4HpUJSgE",
    category: "Comedy",
    cover: "https://i.ytimg.com/vi/2Oy4HpUJSgE/hq720.jpg",
    title: "RAHUL SUBRAMANIAN | LIVE IN BANGALORE | CROWD WORK (PART 1)",
    date: "1 year ago",
    views: "10M views",
    creator: "Rahul Subramanian",
    description:
      "Releasing my second crowd-work video from the show that I did in Bangalore, on 14th September 2019 at That Comedy Club. Crowd work is a sub-genre of stand up comedy, which is completely unscripted and based purely on audience interactions. ",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/T18vEKmT4lg",
    category: "Comedy",
    cover: "https://i.ytimg.com/vi/T18vEKmT4lg/hq720.jpg",
    title: "RAHUL | CROWD WORK | THE COIN DROP MYSTERY",
    date: "2 years ago",
    views: "8M views",
    creator: "Rahul Subramanian",
    description:
      "Releasing my fifth crowd-work video from the show that I did in Delhi, on 14th March 2022 at That Comedy Club. Crowd work is a sub-genre of stand up comedy, which is completely unscripted and based purely on audience interactions. ",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/t4BfHoHawAM",
    category: "Comedy",
    cover: "https://i.ytimg.com/vi/t4BfHoHawAM/hq720.jpg",
    title: "Stand-Up Comedy | Crowd Work by Munawar Faruqui",
    date: "8 months ago",
    views: "11M views",
    creator: "Munawar Faruqui",
    description:
      "Releasing my second crowd-work video from the show that I did in Mumbai, on 11 July 2021 at Habitat. Crowd work is a sub-genre of stand up comedy, which is completely unscripted and based purely on audience interactions. ",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/J38ZBIvLank",
    category: "Comedy",
    cover: "	https://i.ytimg.com/vi/J38ZBIvLank/hqdefault.jpg",
    title: "Bachpan ka pyaar by Gaurav kapoor | Stand up Comedy",
    date: "2 months ago",
    views: "2M views",
    creator: "Gaurav Kapoor",
    description:
      "This video is of on-spot interaction with few kids during the show. And what fun it turned out to be. I hope you will enjoy the video.",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/sU0f5GLJMHE",
    category: "Podcast",
    cover: "https://i.ytimg.com/vi/sU0f5GLJMHE/hq720.jpg",
    title: "Kunal Shah On Startups, Indian Billionaires & Credit Cards",
    date: "15 days ago",
    views: "256K views",
    creator: "Raj Shamani",
    description:
      "I had the privilege of interacting with Kunal Shah, the founder of @CRED_club. Hope this conversation adds as much value to your life, as it did to mine! ",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/B9jZABnvq9A",
    category: "Podcast",
    cover: "https://i.ytimg.com/vi/B9jZABnvq9A/hq720.jpg",
    title:
      "OYO's Founder - Ritesh Agarwal On Building A Billion Dollar Hotel Startup",
    date: "4 hours ago",
    views: "500K views",
    creator: "Raj Shamani",
    description:
      "In today’s Episode of Figuring out With Raj, we have the Founder and Group CEO of OYO, Ritesh Agarwal who is India's youngest self-made billionaire.",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/9yCqE-uE6HE",
    category: "Podcast",
    cover: "https://i.ytimg.com/vi/9yCqE-uE6HE/hq720.jpg",
    title:
      "TOP 10 Rules For Success In Finance, Career & Relationships | Ft. Anant & Rishabh",
    date: "5 days ago",
    views: "100K views",
    creator: "Raj Shamani",
    description:
      "In This Episode Of Figuring Out We've Rishabh Jain from @Labour Law Advisor & Anant Ladha from @Invest Aaj For Kal So if you don't want to Miss Out on knowing what are the Rules/Tips/Hacks which can help you Succeed in your 20s, then WATCH This Episode Till The End!",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/n_Wno11awXA",
    category: "Podcast",
    cover: "	https://i.ytimg.com/vi/n_Wno11awXA/hq720.jpg",
    title:
      "How to be a Successful Creator? Future of Content Creation | ft. Manish Pandey",
    date: "10 days ago",
    views: "100Kviews",
    creator: "Raj Shamani",
    description:
      "In today’s episode of Figuring Out with Raj Shamani, we have Manish Pandey with us. He is currently working as the Head of People Operations and Culture. As an organisation with the mission of unlocking human potential. ",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/GbfjAeHX4P0",
    category: "Music",
    cover: "https://i.ytimg.com/vi/GbfjAeHX4P0/hq720.jpg",
    title:
      "Pyaar Mangdi | Jassi Gill Ft Happy Raikoti | New Romantic Song 2021 | Avvy Sra | Yashika",
    date: "1.5 years ago",
    views: "100M views",
    creator: "Jassie Gill",
    description:
      "This song is for everyone whose in love or seeking it and is shot in Calgary Alberta :)",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/L7mfjvdnPno",
    category: "Music",
    cover: "https://i.ytimg.com/vi/L7mfjvdnPno/hq720.jpg",
    title: "Trevor Daniel - Falling (Official Music Video)",
    date: "3 years ago",
    views: "40M views",
    creator: "Trevor Daniel",
    description:
      "My last made me feel like I would never try again But when I saw you, I felt something I never felt Come closer, give you all my love If you treat me right, baby, I'll give you everything.",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/q-U5nCDAgtY",
    category: "Music",
    cover: "	https://i.ytimg.com/vi/q-U5nCDAgtY/hq720.jpg",
    title:
      "DILJIT DOSANJH: Black & White (Official Music Video) MoonChild Era | Intense | Raj Ranjodh",
    date: "1 year ago",
    views: "30M views",
    creator: "Diljit Dosanjh",
    description:
      "Stream Full Album MoonChild EraHere: https://fanlink.to/MoonChildEra  Presenting official music video Black and White performed by DILJIT DOSANJH from the album MoonChild Era🌻 ",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/cl0a3i2wFcc",
    category: "Music",
    cover: "https://i.ytimg.com/vi/cl0a3i2wFcc/hq720.jpg",
    title: "Diljit Dosanjh - G.O.A.T. (Official Music Video)",
    date: "1.5 years ago",
    views: "100M views",
    creator: "Diljit Dosanjh",
    description:
      "Pre-Order G.O.A.T. album : https://music.apple.com/us/album/g-o- Full album releasing 30 July, 2020. For latest punjabi songs - Subscribe to DILJIT DOSANJH CHANNEL ► ",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/S_V4CdP6aLA&t=180s",
    category: "Self help",
    cover: "https://i.ytimg.com/vi/S_V4CdP6aLA/hqdefault.jpg",
    title: "I read 100 self-help books. Here’s what I learned…",
    date: "5 years ago",
    views: "1.1M views",
    creator: "Matt D'Avella",
    description:
      "I read 100 self-help books. From The Power of Now to Deep Work, to Daring Greatly and Awaken the Giant Within. You can say that I have a bit of a problem. But I learned so much from these books, and the lessons might change the way you look at self-help.",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/6x1i0K4Eg1g",
    category: "Self help",
    cover: "https://i.ytimg.com/vi/6x1i0K4Eg1g/hq720.jpg",
    title: "12 Podcasts that Changed My Life",
    date: "1 year ago",
    views: "101K views",
    creator: "Ali Abdaal",
    description:
      "Other than books, podcasts are the single most important source I've had for learning new ideas over the past 5 years, and it's mostly down to listening to podcasts that I started this YouTube channel and ended up being pretty 'successful'. So in this video I want to share 26 of my favourite podcast recommendations that have, in various ways, helped my life.",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/wIIGCTIpRMk&t=185s",
    category: "Self help",
    cover: "https://i.ytimg.com/vi/wIIGCTIpRMk/hq720.jpg",
    title: "10 small changes that will improve your life.",
    date: "9 months ago",
    views: "786Kviews",
    creator: "Matt D'Avella",
    description:
      "Go check out my habits course: http://slowgrowth.com/simplehabits, Thanks for Watching!!",
  },
  {
    _id: uuid(),
    url: "https://www.youtube.com/embed/aje9UGNi_l0",
    category: "Self help",
    cover: "https://i.ytimg.com/vi/aje9UGNi_l0/hq720.jpg",
    title: "Why you’re always tired (+ food fixes!)",
    date: "3 years ago",
    views: "3M views",
    creator: "Pick Up Limes",
    description:
      "I shared some tips and tricks in this video  So if you don't want to Miss Out on knowing what are the those Tips which can help you to improve your lifestyle, then WATCH This Episode Till The End!",
  },
];
